var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-component",class:_vm.marginClass},[_c('img',{attrs:{"src":require("@/assets/img/spinner.gif")}}),(_vm.label)?_c('div',[_vm._v(_vm._s(_vm.label))]):(_vm.label !== null)?_c('div',[_vm._v("Loading")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }